<template>
  <div class="flex text-sm">
    <div class="flex-1 mr-2">
      <div class="py-1">
        <stacked-input
          :label="i18n.width"
          :required="bothRequired"
          :help="options.width.min + ' → ' + options.width.max"
          :error="errors.width"
        >
          <input
            type="number"
            name="width"
            :required="bothRequired"
            :min="options.width.min"
            :max="options.width.max"
            :value="width"
            @input="updateWidth"
            @blur="updateWidth"
          />
        </stacked-input>
      </div>
    </div>
    <div class="flex-1 ml-2">
      <div class="py-1">
        <stacked-input
          :label="i18n.height"
          :required="bothRequired"
          :help="options.height.min + ' → ' + options.height.max"
          :error="errors.height"
        >
          <input
            type="number"
            name="height"
            :required="bothRequired"
            :min="options.height.min"
            :max="options.height.max"
            :value="height"
            @input="updateHeight"
            @blur="updateHeight"
          />
        </stacked-input>
      </div>
    </div>
  </div>
</template>

<script>
import StackedInput from "../../../../Design/Forms/StackedInput";

export default {
  props: ["options", "required", "i18n", "value", "errors"],
  components: { StackedInput },
  data() {
    return { ...this.value };
  },
  computed: {
    hasWidth() {
      if (
        this.width !== "" &&
        this.width !== null &&
        this.width !== undefined
      ) {
        return true;
      }

      return false;
    },

    hasHeight() {
      if (
        this.height !== "" &&
        this.height !== null &&
        this.height !== undefined
      ) {
        return true;
      }

      return false;
    },

    bothRequired() {
      if (this.required) {
        return true;
      }

      return !!(this.hasWidth || this.hasHeight);
    },
  },
  methods: {
    updateWidth(e) {
      this.width = e.target.value;
      this.$emit("input", { width: this.width, height: this.height });
    },
    updateHeight(e) {
      this.height = e.target.value;
      this.$emit("input", { width: this.width, height: this.height });
    },
  },
};
</script>
